/**
 * ErrorWatchEndIcon/index.tsx
 * desc: end error watch step icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
import IconButton, { type IconProps } from '../IconButton/typed';
import { translate } from '../../../utilities/localization';


const ErrorWatchEndIcon = ({ tooltip, ...props }: IconProps) => (
    <IconButton
        baseClassName="error-watch-end icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.errorWatchEnd.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 1 2 4.5v6.1c0 5 3.8 9.6 9 10.9 5.2-1.3 9-5.9 9-10.9V4.5L11 1Zm0 2.2 7 2.7v4.7c0 4-3 7.7-7 8.9-4-1.2-7-4.9-7-8.9V5.9l7-2.7Z"/>
            <path d="M10 6.5h2v5.5h-2V6.5Zm0 7h2v2h-2v-2Z"/>
        </svg>
    </IconButton>
);


export default ErrorWatchEndIcon;
